import React from 'react';
import { motion } from 'framer-motion';
import './QuizeethonSection.css';

const QuizeethonSection = () => {
  const winners = [
    {
      id: 1,
      name: 'Winner 01',
      rank: '1st Rank',
      image: '/assets/images/events/superx2025/first.jpg',
      prize: 'Gold Trophy + MacBook'
    },
    {
      id: 2,
      name: 'Winner 02',
      rank: '2nd Rank',
      image: '/assets/images/events/superx2025/second.jpg',
      prize: 'Silver Trophy + iPad'
    },
    {
      id: 3,
      name: 'Winner 03',
      rank: '3rd Rank',
      image: '/assets/images/events/superx2025/third (2).jpg',
      prize: 'Bronze Trophy + Smart Watch'
    }
  ];

  return (
    <section className="ucp-section quizeethon-section">
      <div className="quizeethon-container">
        <div className="quizeethon-header">
          <motion.img
            src="/assets/quizeethon/landing/QuizeethonLogo.png"
            alt="Quizeethon Logo"
            className="quizeethon-logo"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          />
          <motion.h2
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            The Ultimate <span className="gold-text">Technical Battle</span>
          </motion.h2>
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            Compete with the best minds, solve complex puzzles, and win grand prizes.
            Quizeethon is where logic meets speed.
          </motion.p>
        </div>

        <div className="winners-showcase">
          <h3 className="hall-of-fame-title">Hall of Fame</h3>

          <div className="infinite-slider-ctn">
            <div className="slider-track">
              {[...Array(10)].map((_, i) => (
                <div key={i} className="slide-item">
                  <img src={`/assets/images/upcomingCourse/${i + 1}_quiz.PNG`} alt={`Winner ${i + 1}`} />
                </div>
              ))}
              {/* Duplicate for seamless loop */}
              {[...Array(10)].map((_, i) => (
                <div key={`dup-${i}`} className="slide-item">
                  <img src={`/assets/images/upcomingCourse/${i + 1}_quiz.PNG`} alt={`Winner ${i + 1}`} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuizeethonSection;
